const sizeBarge = state => state.sizeBarge.data;
const errorSizeBarge = state => state.errorSizeBarge;
const isLoadingSizeBarge = state => state.isLoadingSizeBarge;

const sizeLCT = state => state.sizeLCT.data;
const errorSizeLCT = state => state.errorSizeLCT;
const isLoadingSizeLCT = state => state.isLoadingSizeLCT;

const commodities = state => state.commodities.data;
const errorDataCommodities = state => state.errorDataCommodities;
const isLoadingDataCommodities = state => state.isLoadingDataCommodities;

export default {
  sizeBarge,
  errorSizeBarge,
  isLoadingSizeBarge,

  sizeLCT,
  errorSizeLCT,
  isLoadingSizeLCT,

  commodities,
  errorDataCommodities,
  isLoadingDataCommodities
};



// WEBPACK FOOTER //
// ./src/store/modules/vessel-charter/getters.js